import { Form } from "antd";

import { useSetOpportunityUsers } from "data/use-opportunities";
import { UserSelect } from "components/selects/user-select";
import { useOnChange } from "hooks/use-on-change";
import { Modal } from "components/modal";

export const SetUsers = ({ close, isOpen, opportunity }) => {
  const setOpportunityUsers = useSetOpportunityUsers({
    onSuccess: close,
  });

  const [form] = Form.useForm();

  const onFinish = async (values) => {
    setOpportunityUsers.mutate({
      id: opportunity._id,
      userIds: values.userIds,
    });
  };

  useOnChange(
    isOpen,
    () => {
      if (!isOpen) {
        return;
      }

      form.setFieldsValue({
        userIds: opportunity.users,
      });
    },
    [isOpen, form, opportunity]
  );

  return (
    <Modal
      confirmLoading={setOpportunityUsers.isLoading}
      okText="Set Sales Reps"
      onCancel={close}
      onOk={form.submit}
      title="Sales Reps"
      open={isOpen}
    >
      <Form
        form={form}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 18 }}
        onFinish={onFinish}
      >
        <UserSelect
          label="Sales Reps"
          mode="multiple"
          name="userIds"
          placeholder="Select sales reps"
        />
      </Form>
    </Modal>
  );
};
